import { render } from "./ProfessionsCostView.vue?vue&type=template&id=f6f00f10&scoped=true"
import script from "./ProfessionsCostView.vue?vue&type=script&lang=js"
export * from "./ProfessionsCostView.vue?vue&type=script&lang=js"

import "./ProfessionsCostView.vue?vue&type=style&index=0&id=f6f00f10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f00f10"]])

export default __exports__